import { Link } from 'gatsby';
import React from 'react';
import useMenu from '../hooks/use-menu';

export default () => {
  const menuLinks = useMenu();

  return (
    <div id="main-menu" className="main-menu">
      <ul>
        {menuLinks.map((link) => (
          <li key={link.name}>
            <Link to={link.link}>{link.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
